import { useEffect, useState } from 'react';

export function currentPath() {
  const path = window.location.pathname.replace(/\/+$/, '');
  return path || '/';
}

export function currentSearch() {
  return window.location.search;
}

export function navigate(to) {
  const nextUrl = new URL(to, window.location.origin);
  const next = `${nextUrl.pathname}${nextUrl.search}`;
  const current = `${window.location.pathname}${window.location.search}`;
  if (next === current) return;
  window.history.pushState({}, '', next);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function useLocation() {
  const [location, setLocation] = useState(() => ({
    path: currentPath(),
    search: currentSearch(),
  }));

  useEffect(() => {
    const sync = () => {
      setLocation({
        path: currentPath(),
        search: currentSearch(),
      });
    };

    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);

  return location;
}

export function NavLink({ to, className, children, ...rest }) {
  const handleClick = (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    navigate(to);
  };

  return (
    <a href={to} className={className} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
